import williamPic from "@/public/images/artists/william.png";
import { Artist } from "@/types/types";

export const william = {
  id: "124",
  name: "William",
  image: williamPic,
  description: `William's voice is defined by its smooth, resonant timbre and charismatic delivery. The voice's dynamic range is moderately wide, enabling it to convey both intensity and calm with equal effectiveness. Articulation is crisp yet relaxed, with a rhythmic cadence that complements musical backgrounds effectively.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fwilliam-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Spoken Word", "Hip Hop", "Deep"],
      secondary: ["British"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 48,
        high: 62,
      },
    },
  },
} as const satisfies Artist;
